<template>
	<v-row no-gutters class="welcome-banner__container background-banner-welcome-page" style="position: relative;">
		<img :src="AppConfigs.staticImages.HOMEBANNERITEM3" class="welcome-banner__hero-image__item-3" />

		<v-col class="d-flex flex-column align-center pa-3">

			<div class="welcome-banner__hero-image-container w-100 d-flex flex-row align-center justify-center">
				<img :src="AppConfigs.staticImages.HOMEBANNERITEM1" class="welcome-banner__hero-image__item-1" />
				<img :src="AppConfigs.staticImages.HOMEBANNERITEM2" class="welcome-banner__hero-image__item-2" />
			</div>


			<div class="welcome-banner__title text-center mt-7">
				Play Games & Earn Rewards
			</div>

			<div class="welcome-banner__subtitle text-center">
				Complete Offers, Earn Rewards, Refer Friends & Win Prizes
			</div>

			<button v-if="isUserLoggedIn" @click="startPlayingClicked"
				class="welcome-banner__cta button--primary rounded-pill d-flex mt-7">
				Start Playing
			</button>

			<button v-else @click="joinNowClicked" class="welcome-banner__cta button--primary rounded-pill d-flex mt-7">
				Join Now
			</button>
		</v-col>

	</v-row>
</template>


<script>

import { computed, ref } from "vue";
import { AppConfigs } from "@/app.configs";
import authEvents from "@/Events/AuthDialog";
import { useAuthStore } from "@/store/AuthStore";
import { useSnackbar } from '@/composables/useSnackbar';
import { useRouter } from 'vue-router';

/* global google */
/* global FB */

export default {
	name: "WelcomeAndSignup",
	components: {
	},
	setup() {
		const router = useRouter();
		const authStore = useAuthStore();
		// authStore.initialize(); TODO: check this later
		const { showSnackbar } = useSnackbar();

		const isUserLoggedIn = computed(() => {
			return authStore.isUserLoggedIn();
		});

		const dialogVisible = ref(false);
		let isLoading = ref(false);


		const joinNowClicked = () => {
			authEvents.emit('open-auth-dialog');
		};

		const startPlayingClicked = () => {
			router.push('/earn');
		};


		const fbLogin = () => {
			isLoading.value = true;
			FB.login(
				(response) => {
					if (response.authResponse) {
						const accessToken = response.authResponse.accessToken;
						FB.api(
							"/me/permissions",
							{ access_token: accessToken },
							(permsResponse) => {
								const hasEmailPermission = permsResponse.data.some(
									(perm) =>
										perm.permission === "email" && perm.status === "granted"
								);
								if (hasEmailPermission) {
									authStore.facebookLoginResponse = response;
								} else {
									showSnackbar({
										message: "Email permission not granted",
										color: "error",
									});
								}
							}
						);
					} else {
						showSnackbar({
							message: "Login Failed",
							color: "error",
						});
					}
					isLoading.value = false;
				},
				{
					scope: "email",
				}
			);
		};

		const handleCredentialResponse = (response) => {
			isLoading.value = true;
			authStore.googleLoginResponse = response;
		};

		const initGis = () => {
			google.accounts.id.initialize({
				client_id: AppConfigs.googleAppId,
				callback: handleCredentialResponse,
			});

			google.accounts.id.renderButton(document.getElementById("g_id_signin"), {
				theme: "outline",
				size: "large",
				shape: "pill",
			});
		};

		return {
			authStore,
			showSnackbar,
			isUserLoggedIn,
			AppConfigs,
			isLoading,
			dialogVisible,
			handleCredentialResponse,
			fbLogin,
			initGis,
			joinNowClicked,
			startPlayingClicked
		};
	},
	mounted() {
		const script = document.createElement("script");
		script.src = "https://accounts.google.com/gsi/client";
		script.async = true;
		script.defer = true;
		script.onload = this.initGis;
		document.head.appendChild(script);
	},
};
</script>



<style scoped lang="scss">
// this needs to be here for some reason. blame vue</style>
